<div class="close-container">
    <mat-icon class="close-icon" (click)="dialogRef.close()"></mat-icon>
</div>
<div class="title title--lg dialog" mat-dialog-title>Faculty Removal Confirmation</div>
<mat-dialog-content>
    <div class="list-font">Are you sure you want to remove this faculty member?</div>
    <div class="list-font faculty-name">{{facultyMember.lastName}}, {{facultyMember.firstName}}</div>
    <div class="list-font faculty-name">{{facultyMember.emailAddress}}</div>
    <div class="list-font faculty-name"><b>Role: </b>{{facultyMember.roleName}}</div>
    <div class="error" *ngIf="removeFacultyError">There was an error in removing the faculty member. If the error persists please contact Customer Service.</div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="btn--inline dialog-btn-container">
        <button [disabled]="removeFacultyError" (click)="removeFaculty()" class="btn btn--solid btn--red">Remove</button>
        <button (click)="dialogRef.close()" class="btn btn--outline">Cancel</button>
    </div>
</mat-dialog-actions>
<aaos-spinner [isLoading]="loading"></aaos-spinner>
